<template>
  <div class="marketplace-page-not-found">
    <h2>{{ 'Page not found' | t }}</h2>
  </div>
</template>

<script>
import t from '../../main/i18n';

export default {
  filters: {
    t
  }
};
</script>

<style scoped lang="scss">
.marketplace-page-not-found {
  text-align: center;
  margin-block-start: 6.4rem;
}
</style>
